var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.624,
    height: 50.509,
    viewBox: "0 0 46.624 50.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-24 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1154",
    "data-name": "Trac\\xE9 1154",
    d: "M66.738,15.885H58.968V12H55.082v3.885H39.541V12H35.656v3.885H27.885A3.9,3.9,0,0,0,24,19.771V58.624a3.9,3.9,0,0,0,3.885,3.885H66.738a3.9,3.9,0,0,0,3.885-3.885V19.771A3.9,3.9,0,0,0,66.738,15.885Zm0,42.738H27.885v-27.2H66.738Zm0-31.082H27.885V19.771h7.771v3.885h3.885V19.771H55.082v3.885h3.885V19.771h7.771Z",
    fill: "#b4a14a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.3b10552e70d70260bd5736d64b9bfcc2.svg";
export { ForwardRef as ReactComponent };